// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"3feffbb1","247":"2a338d4a","284":"d47a8165","627":"00f52804","867":"6dbdb37b","923":"ede27252","938":"78cb0f52"}[chunkId] + ".chunk.js";
};